export const convertBoolean = (value?: string | number | boolean): boolean => {
  if (!value) {
    return false;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number' && value > 0) {
    return true;
  }

  if (typeof value === 'string') {
    const trueValues = ['1', 'true', 'yes'];
    const cleaned = value.toLowerCase().replaceAll(' ', '');

    if (trueValues.includes(cleaned)) {
      return true;
    }
  }

  return false;
};
